import React, { StrictMode } from "react";
import { BrandListItem } from "@App/Components/Vehicletree/BrandList";
import { Brand } from "@App/types";

type BrandListItemGroupProps = {
  name: string;
  group: Brand[];
  onClick: (brand: Brand) => void;
};

export const BrandListItemGroup = React.memo<BrandListItemGroupProps>(
  (props: BrandListItemGroupProps) => {
    return (
      <StrictMode>
        <div className={"my-3"}>{props.name}</div>
        <div>
          {props.group &&
            props.group.map((brand) => (
              <BrandListItem key={brand.id} brand={brand} onClick={props.onClick} />
            ))}
        </div>
      </StrictMode>
    );
  },
);
